const getAuthUserId = (state) => {
    return state.auth.userId;
};

export { getAuthUserId };